import fs from '@/components/atoms/Fieldset';
import { Skeleton } from '@/components/ui/skeleton';

const InvitationSkeleton = () => {
  return (
    <fs.Fieldset>
      <div className="flex items-center gap-4">
        <Skeleton className="size-10 shrink-0 rounded-full" />
        <div className="flex-1 space-y-2">
          <Skeleton className="h-4 w-48" />
          <Skeleton className="h-4 w-32" />
        </div>
        <div className="flex items-center gap-3">
          <Skeleton className="size-8 rounded-md" />
          <Skeleton className="size-8 rounded-md" />
        </div>
      </div>
    </fs.Fieldset>
  );
};

export default InvitationSkeleton;
